// The priority flag: a clickable "!".
//
// Replaces the old High/Medium/Low StatusOption dropdown. Red when flagged,
// grey when not.
export default function FlagCell({ flagged, onChange }) {
  return (
    <div
      role="button"
      tabIndex={0}
      aria-pressed={!!flagged}
      title={flagged ? "Flagged — click to clear" : "Click to flag"}
      onClick={() => onChange(!flagged)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onChange(!flagged);
        }
      }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        cursor: "pointer",
        userSelect: "none",
        fontSize: 18,
        fontWeight: 800,
        lineHeight: 1,
        color: flagged ? "#e2445c" : "#d0d4e4",
      }}
    >
      !
    </div>
  );
}
